import React from 'react';

const Checkbox = ({ name, disabled, checked, halfChecked, onChange, label, className }) => (
    <span
        className={`ckp-checkbox ${className ? className : ''}  ${disabled ? 'is-disabled' : ''} ${
            halfChecked ? 'is-half-checked' : ''
        }`}
    >
        <input
            disabled={!!disabled}
            type="checkbox"
            onChange={onChange}
            name={name}
            id={`ckp-checkbox-${name}`}
            checked={checked}
        />
        <label htmlFor={`ckp-checkbox-${name}`}>
            <span className="is-checkbox" />
            {label ? <span className="is-label">{label}</span> : null}
        </label>
    </span>
);

export default Checkbox;

// TODO-NT Use material UI checkbox.



// WEBPACK FOOTER //
// ./src/components/forms/Checkbox.js